import { getDiffKeys } from '@/libraries/utils';

export const types = {
  SET_RESUMES: 'SET_RESUMES',
  SET_METRICS: 'SET_METRICS',
  SET_RESUME: 'SET_RESUME',
  SET_RESUME_CANDIDATE: 'SET_RESUME_CANDIDATE',
  UPDATE_CURRENT_RESUME: 'UPDATE_CURRENT_RESUME',
  UPDATE_CURRENT_RESUME_CONTACT: 'UPDATE_CURRENT_RESUME_CONTACT',
  DELETE_RESUME: 'DELETE_RESUME',
  SET_ITEM: 'SET_ITEM',
  SET_ITEM_CONTENT: 'SET_ITEM_CONTENT',
  UPDATE_ITEM: 'UPDATE_ITEM',
  DELETE_ITEM: 'DELETE_ITEM',
  SET_TEMPLATES: 'SET_TEMPLATES',
  SET_CONTACTS: 'SET_CONTACTS',
  SET_FETCH: 'SET_FETCH',
  UPDATE_CURRENT_RESUME_TEMPLATE: 'UPDATE_CURRENT_RESUME_TEMPLATE',
  SET_UNDO: 'SET_UNDO',
  SET_CURRENT_RESUME: 'SET_CURRENT_RESUME',
  SET_EMAIL_NOTIFICATION: 'SET_EMAIL_NOTIFICATION',
  SET_ACTIVE_COLOR_PALETTE: 'SET_ACTIVE_COLOR_PALETTE',
  SET_MODE: 'SET_MODE',
  SET_LEFT_PANEL_WIDTH: 'SET_LEFT_PANEL_WIDTH',
  SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
  SET_RESET_SEARCH: 'SET_RESET_SEARCH',
  SET_REDO: 'SET_REDO',
  DO_UNDO: 'DO_UNDO',
  DO_REDO: 'DO_REDO',
  RESET_UNDO_REDO: 'RESET_UNDO_REDO',
  UPDATE_ITEM_ID: 'UPDATE_ITEM_ID',
  SET_SAVING_RESUME: 'SET_SAVING_RESUME',
  SET_RESUMES_SCROLL: 'SET_RESUMES_SCROLL',
  SET_SEARCH_RESUMES_SCROLL: 'SET_SEARCH_RESUMES_SCROLL',
  SET_LABELS: 'SET_LABELS',
};

let loadingTimer = null;
const timerDuration = 2000;

export const mutations = {
  [types.SET_MODE](state, mode) {
    state.currentMode = mode;
  },
  [types.SET_SAVING_RESUME](state, msg) {
    state.savingResume = msg;
  },
  [types.SET_RESUMES](state, resumes) {
    state.resumes = resumes;
  },
  [types.SET_METRICS](state, metrics) {
    state.metrics = metrics;
  },
  [types.SET_CURRENT_RESUME](state, resume) {
    if (!resume) {
      state.currentResume = '';
      return;
    }
    state.loading = true;
    clearTimeout(loadingTimer);
    resume.items = resume.items.map(i => {
      try {
        const content = JSON.parse(i.content);
        return { ...i, content };
      } catch (e) {
        console.error(`content are not JSON for item ${i.id} : ${i.content}`);
        return i;
      }
    });
    resume.template.settings = JSON.parse(resume.template.settings);

    state.currentMode = 'preview';
    state.currentResume = resume;
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(e => {
      state.loading = false;
    }, timerDuration);
  },
  [types.UPDATE_CURRENT_RESUME](state, resume) {
    state.loading = true;
    clearTimeout(loadingTimer);
    Object.assign(state.currentResume, resume);
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(e => {
      state.loading = false;
    }, timerDuration);
  },
  [types.UPDATE_CURRENT_RESUME_CONTACT](state, contact) {
    Object.assign(state.currentResume.contact, contact);
  },
  [types.UPDATE_CURRENT_RESUME_TEMPLATE](state, { template }) {
    state.loading = true;
    clearTimeout(loadingTimer);
    Object.assign(state.currentResume.template, template);
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(e => {
      state.loading = false;
    }, timerDuration);
  },
  [types.DELETE_RESUME](state, resumeId) {
    state.loading = true;
    const index = state.resumes.items.findIndex(group => {
      const index = group.resumes.findIndex(r => r.id === resumeId);

      if (index >= 0) {
        if (group.resumes.length === 1) {
          return true;
        }
        group.resumes.splice(index, 1);
      }
      return false;
    });
    if (index >= 0) {
      state.resumes.items.splice(index, 1);
    }
  },
  [types.SET_ITEM](state, { item }) {
    state.loading = true;
    clearTimeout(loadingTimer);
    if (item.content) {
      item.content = JSON.parse(item.content);
    }
    const itemIndex = state.currentResume.items.findIndex(i => i.id === item.id);
    if (itemIndex >= 0) {
      state.currentResume.items[itemIndex] = item;
    } else {
      state.currentResume.items.push(item);
    }
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(e => {
      state.loading = false;
    }, timerDuration);
  },
  [types.UPDATE_ITEM](state, item) {
    state.loading = true;
    clearTimeout(loadingTimer);
    if (item.content) {
      item.content = JSON.parse(item.content);
    }

    const itemIndex = state.currentResume.items.findIndex(i => i.id === item.id);
    if (itemIndex >= 0) {
      Object.assign(state.currentResume.items[itemIndex], item);
    } else {
      console.error('item do not exist');
    }
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(e => {
      state.loading = false;
    }, timerDuration);
  },
  [types.UPDATE_ITEM_ID](state, { previousId, newId }) {
    state.undo.forEach(thing => {
      if (thing.itemId === previousId) {
        thing.itemId = newId;
        thing.item.id = newId;
      }
    });
    state.redo.forEach(thing => {
      if (thing.itemId === previousId) {
        thing.itemId = newId;
        thing.item.id = newId;
      }
    });
  },
  [types.SET_UNDO](state, { itemId, actionType, item, content }) {
    const itemIndex = state.currentResume?.items?.findIndex(i => i.id === itemId);
    let keyChanged;
    if (state.undo.length) {
      if (!content && (!item || !item.content)) {
        const { order } = state.undo[state.undo.length - 1].item;
        keyChanged = order !== item.order ? 'order' : 'nothing';
      } else {
        keyChanged = getDiffKeys(state.undo[state.undo.length - 1].item.content, item ? item.content : content);
      }
      const isLastUndoItem =
        state.undo[state.undo.length - 1].itemId === itemId &&
        state.undo[state.undo.length - 1].keyChanged === keyChanged &&
        actionType === state.undo[state.undo.length - 1].actionType;
      if (isLastUndoItem) {
        return;
      }
    }
    if (itemIndex >= 0) {
      if (!content && (!item || !item.content)) {
        const { order } = state.currentResume.items[itemIndex];
        keyChanged = order !== item.order ? 'order' : 'nothing';
      } else {
        keyChanged = getDiffKeys(state.currentResume.items[itemIndex].content, item ? item.content : content);
      }
      state.undo.push({
        resumeId: state.currentResume.id,
        itemId,
        itemIndex,
        actionType,
        keyChanged,
        item: JSON.parse(JSON.stringify(state.currentResume.items[itemIndex])),
      });
    } else {
      state.undo.push({
        resumeId: state.currentResume.id,
        itemId,
        itemIndex,
        actionType,
        item: JSON.parse(JSON.stringify(item)),
      });
    }
    state.redo = [];
  },
  [types.SET_REDO](state, { itemId, actionType }) {
    const itemIndex = state.currentResume.items.findIndex(i => i.id === itemId);
    if (itemIndex >= 0) {
      state.redo.push({
        resumeId: state.currentResume.id,
        itemId,
        itemIndex,
        actionType,
        item: JSON.parse(JSON.stringify(state.currentResume.items[itemIndex])),
      });
    }
  },
  async [types.DO_UNDO](state) {
    const undoItem = state.undo.pop();
    const itemIndex = state.currentResume.items.findIndex(i => i.id === undoItem.itemId);

    switch (undoItem.actionType) {
      case 'Edit':
        state.redo.push(
          Object.assign(
            { ...undoItem },
            {
              item: JSON.parse(JSON.stringify(state.currentResume.items[itemIndex])),
            }
          )
        );
        state.currentResume.items[itemIndex].content = undoItem.item.content;
        state.currentResume.items[itemIndex].order = undoItem.item.order;
        break;
      case 'Create':
        state.redo.push(
          Object.assign(
            { ...undoItem },
            {
              item: JSON.parse(JSON.stringify(state.currentResume.items[itemIndex])),
            }
          )
        );
        state.currentResume.items.splice(itemIndex, 1);
        break;
      case 'Delete':
        state.currentResume.items.push(undoItem.item);
        state.redo.push(undoItem);
        break;
      default:
        console.error('undo type : ' + undoItem.actionType + ', is not implemented');
    }
  },
  [types.DO_REDO](state) {
    const redoItem = state.redo.pop();
    const itemIndex = state.currentResume.items.findIndex(i => i.id === redoItem.itemId);
    switch (redoItem.actionType) {
      case 'Edit':
        state.undo.push(
          Object.assign(
            { ...redoItem },
            {
              item: JSON.parse(JSON.stringify(state.currentResume.items[itemIndex])),
            }
          )
        );
        state.currentResume.items[itemIndex].content = redoItem.item.content;
        state.currentResume.items[itemIndex].order = redoItem.item.order;
        break;
      case 'Create':
        state.currentResume.items.push(redoItem.item);
        state.undo.push(redoItem);
        break;
      case 'Delete':
        state.undo.push(
          Object.assign(
            { ...redoItem },
            {
              item: JSON.parse(JSON.stringify(state.currentResume.items[itemIndex])),
            }
          )
        );
        state.currentResume.items.splice(itemIndex, 1);
        break;
      default:
        console.error('redo type : ' + redoItem.type + ', is not implemented');
    }
  },
  [types.RESET_UNDO_REDO](state) {
    state.undo = [];
    state.redo = [];
  },
  [types.SET_ITEM_CONTENT](state, { itemId, content }) {
    state.loading = true;
    clearTimeout(loadingTimer);
    const itemIndex = state.currentResume.items.findIndex(i => i.id === itemId);
    if (itemIndex >= 0) {
      state.currentResume.items[itemIndex].content = content;
    } else {
      console.error('no item found locally for ' + itemId);
    }
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(e => {
      state.loading = false;
    }, timerDuration);
  },
  [types.DELETE_ITEM](state, itemId) {
    state.loading = true;
    clearTimeout(loadingTimer);
    const index = state.currentResume.items.findIndex(i => i.id === itemId);

    if (index >= 0) {
      state.currentResume.items.splice(index, 1);
    } else {
      console.error('resume do not exist');
    }
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(e => {
      state.loading = false;
    }, timerDuration);
  },
  [types.SET_TEMPLATES](state, templates) {
    templates.forEach(t => {
      t.settings = JSON.parse(t.settings);
    });
    state.templates = templates;
  },
  [types.SET_CONTACTS](state, contacts) {
    state.contacts = contacts;
  },
  [types.SET_FETCH](state, { type, isFetching }) {
    state.fetchingData[type] = isFetching;
  },
  [types.SET_EMAIL_NOTIFICATION](state, email) {
    state.emailNotification = email;
  },
  [types.SET_ACTIVE_COLOR_PALETTE](state, palette) {
    state.activeColorPalette = palette;
  },
  [types.SET_LEFT_PANEL_WIDTH](state, width) {
    state.leftPannelWidth = width;
    localStorage.setItem('panelSize', width);
  },
  [types.SET_SEARCH_RESULT](state, search) {
    state.searchResult = search;
  },
  [types.SET_RESET_SEARCH](state) {
    state.resetSearch = new Date().getTime();
  },
  [types.SET_RESUMES_SCROLL](state, resumes) {
    state.resumes = {
      offSet: resumes.offSet,
      total: resumes.total,
      items: state.resumes.items.concat(resumes.items),
    };
  },
  [types.SET_SEARCH_RESUMES_SCROLL](state, resumes) {
    state.searchResult = {
      offSet: resumes.offSet,
      total: resumes.total,
      items: state.searchResult.items.concat(resumes.items),
    };
  },
};
